

























































































import { Component, Vue, Prop, Ref, Watch } from "vue-property-decorator";
import { FocusedTask } from "@/data/models/Task";

import { PlanningParameters } from "@/data/models/PlanningParameters";

import {
  getDateFromYearMonthDateString,
  getDateFromHoursAndMinuteString,
  formatDateToHoursAndMinuteString,
  formatDateToYearMonthDateString,
} from "@/utils/DateHelper";

import { firestore } from "firebase/app";
import { SchedulingModule } from "@/store/modules/SchedulingModule";

import UserPickerComponent from "@/components/common/UserPickerComponent.vue";
import DatePickerCompoment from "../common/DatePicker.vue";
import TimePickerComponent from "../common/TimePicker.vue";

import User from "@/data/models/User";
import { COLOR_SCHEDULING_CHECKBOX } from "@/utils/colors";

@Component({
  components: {
    "date-picker": DatePickerCompoment,
    "time-picker": TimePickerComponent,
    "user-picker": UserPickerComponent,
  },
})
export default class PlanningParametersComponent extends Vue {
  @Prop()
  focusedTask!: FocusedTask;

  @Prop()
  editEnabled!: boolean;

  @Prop()
  minDate!: firestore.Timestamp;

  @Prop()
  usersForSelection!: User[];

  @Ref("timePicker")
  timePicker!: TimePickerComponent;

  checkBoxColor = COLOR_SCHEDULING_CHECKBOX;

  @Watch("focusedTask", { immediate: true })
  onFocusedTaskChanged(
    newFocusedTask: FocusedTask,
    oldFocusedTask?: FocusedTask
  ) {
    if (newFocusedTask.id !== oldFocusedTask?.id && oldFocusedTask) {
      this.timePicker.setNewInternalDate(this.targetTime);
    }
  }

  get isTargetDateFixed() {
    return this.focusedTask?.planningParameters?.isTargetDateFixed ?? false;
  }

  set isTargetDateFixed(value: boolean) {
    this.updatePlanningParameter((currentPlanningParameters) => {
      return {
        ...currentPlanningParameters,
        isTargetDateFixed: value,
      };
    });
  }

  get isTargetTimeFixed() {
    return this.focusedTask?.planningParameters?.isTargetTimeFixed ?? false;
  }

  set isTargetTimeFixed(value: boolean) {
    this.updatePlanningParameter((currentPlanningParameters) => {
      return {
        ...currentPlanningParameters,
        isTargetTimeFixed: value,
      };
    });
  }

  get isTargetUserFixed() {
    return this.focusedTask?.planningParameters?.isTargetUserFixed ?? false;
  }

  set isTargetUserFixed(value: boolean) {
    const focusedTask = SchedulingModule.focusedTask 

    this.updatePlanningParameter((currentPlanningParameters) => {
      return {
        ...currentPlanningParameters,
        isTargetUserFixed: value,
        targetUserId: currentPlanningParameters.targetUserId ?? focusedTask?.userId ?? null
      };
    });
  }

  updatePlanningParameter(
    updateCurrenValueCallback: (
      parameters: PlanningParameters
    ) => PlanningParameters
  ) {
    const planningParameters = updateCurrenValueCallback(
      this.focusedTask.planningParameters ?? {
        isTargetDateFixed: false,
        isTargetTimeFixed: false,
        isTargetUserFixed: false,
      }
    );

    SchedulingModule.updateFocusedTask({
      id: this.focusedTask.id,
      updateScheduledTask: true,
      planningParameters,
    });
  }

  get targetUserId() {
    return this.focusedTask.planningParameters.targetUserId;
  }

  set targetUserId(targetUserId: string | null) {
    if (targetUserId !== this.focusedTask.planningParameters.targetUserId) {
      this.updatePlanningParameter((currentPlanningParameters) => {
        return {
          ...currentPlanningParameters,
          targetUserId,
          isTargetUserFixed: targetUserId
            ? this.focusedTask.planningParameters.isTargetUserFixed
            : false,
        };
      });
    }
  }

  get targetDate() {
    const date = getDateFromYearMonthDateString(
      this.focusedTask?.planningParameters?.targetDate
    );

    if (!date) {
      return null;
    }

    return firestore.Timestamp.fromDate(date);
  }

  set targetDate(timestamp: firestore.Timestamp | null) {
    const targetDate = timestamp
      ? this.formatDateToTargetDate(timestamp.toDate())
      : null;

    this.updatePlanningParameter((currentPlanningParameters) => {
      return {
        ...currentPlanningParameters,
        targetDate,
        isTargetDateFixed: targetDate
          ? this.focusedTask.planningParameters.isTargetDateFixed
          : false,
      };
    });
  }

  get targetTime() {
    const date = getDateFromHoursAndMinuteString(
      this.focusedTask?.planningParameters?.targetTime
    );

    if (!date) {
      return null;
    }

    return firestore.Timestamp.fromDate(date);
  }

  set targetTime(timestamp: firestore.Timestamp | null) {
    const targetTime = timestamp
      ? this.formatDateToTargetTime(timestamp.toDate())
      : null;

    this.updatePlanningParameter((currentPlanningParameters) => {
      return {
        ...currentPlanningParameters,
        targetTime,
        isTargetTimeFixed: targetTime
          ? this.focusedTask.planningParameters.isTargetTimeFixed
          : false,
      };
    });
  }

  get canSetTargetDateFixed() {
    return this.focusedTask.planningParameters.targetDate && this.editEnabled;
  }

  get canSetTargetTimeFixed() {
    return this.focusedTask.planningParameters.targetTime && this.editEnabled;
  }

  get canSetTargetUserFixed() {
    return this.focusedTask.planningParameters.targetUserId && this.editEnabled;
  }

  formatDateToTargetTime(date: Date): string {
    return formatDateToHoursAndMinuteString(date);
  }

  formatDateToTargetDate(date: Date): string {
    return formatDateToYearMonthDateString(date);
  }
}
